import React, { useState, useEffect, useRef } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { useSelector, useDispatch } from 'react-redux'
import { CoreBreadcrumb } from 'src/components/core'
import { patchCourseCollectionAction } from 'src/reducers/collection/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { Icon } from '@iconify/react'

const CollectionHeader = props => {
  const { classes } = props
  const { collection } = useSelector(state => state.collection)
  const dispatch = useDispatch()
  const [title, setTitle] = useState(collection?.name)
  const [hoveredCollectionNaming, setHoveredCollectionNaming] = useState(false)
  const titleRef = useRef(null)

  useEffect(() => {
    if (collection) {
      setTitle(collection.name)
    }
  }, [collection])

  const handleTitleChange = e => {
    setTitle(e.target.textContent)
  }

  const onBlurTitle = () => {
    // use titleRef to get the text content
    const title = titleRef.current.textContent
    if (collection?.name !== title) {
      const patchSource = new PatchData(null, collection.id)
      patchSource.addContent(
        new PatchContent(title, 'collectionName', PatchData.OPERATION_REPLACE),
      )
      dispatch(patchCourseCollectionAction(patchSource, () => {}))
    }
  }

  const breadcrumbLinks = [
    {
      name: 'Collections',
      href: '/collections',
    },
    {
      name: collection?.name || 'Collection Title',
      href: '#',
    },
  ]

  return (
    <div className={classes.root}>
      <div
        onMouseEnter={() => setHoveredCollectionNaming(true)}
        onMouseLeave={() => setHoveredCollectionNaming(false)}
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 4,
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div
          ref={titleRef}
          contentEditable
          suppressContentEditableWarning
          className={classes.editableTitle}
          onBlur={onBlurTitle}
          onChange={handleTitleChange}
          //make sure its one line only
          style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
        >
          {title}
        </div>

        <Icon
          icon="fluent:edit-24-filled"
          fontSize={16}
          color="#002E47"
          style={{ display: hoveredCollectionNaming ? 'block' : 'none' }}
        />
      </div>
      <CoreBreadcrumb links={breadcrumbLinks} />
    </div>
  )
}

export default withStyles(styles)(CollectionHeader)
